import React, { SetStateAction } from "react";
import Entity from "components/Entity";
import { WorkflowListData } from "../WorkflowConfigurations";
import { endpoints } from "config";
import ProgressBar from "components/helpers/ProgressBar/ProgressBar";
import {
  workflowReadOnlyRightsRenderer,
  workflowRightsRenderer,
  workflowValidationSchema,
} from "../WorkflowConfiguration";
import { stringReadOnlyEditRenderer } from "components/helpers/CustomFieldRenderers/CustomString/StringReadOnlyEditFieldRenderer";
import { Pages } from "./WorkflowCreateEdit";

type WorkflowCreateEditDetailsProps = {
  actionType: "create" | "edit" | "view";
  originalActionType: "create" | "edit" | "view";
  selectedData: WorkflowListData[];
  onDone(): void;
  idFromRowOption: React.ReactText | null;
  submitButtonText?: string;
  hideActionButton?: boolean;
  currentPageNumber: number;
  totalPages: number;
  cancelOnDone: () => void;
  workflowId?: number | null;
  onValuesChangeDetails?: (values: any) => void;
  currentPage: Pages;
  setCurrentPage: React.Dispatch<SetStateAction<Pages>>;
};

// Validation???
// Rights Renderer?
// Read only rights renderer?

const fetchConfig = (
  selectedRows: WorkflowListData[],
  idFromRowOption?: React.ReactText | null
) => {
  return {
    params: {
      Id: idFromRowOption ?? selectedRows[0].workflows__ID,
    },
  };
};

const WorkflowCreateEditDetails: React.FC<WorkflowCreateEditDetailsProps> = ({
  actionType,
  originalActionType,
  selectedData,
  onDone,
  idFromRowOption,
  submitButtonText,
  hideActionButton,
  currentPageNumber,
  totalPages,
  cancelOnDone,
  workflowId,
  onValuesChangeDetails,
  currentPage,
  setCurrentPage,
}) => {
  let initialDataUrl = "";

  if (actionType === "view")
    initialDataUrl = endpoints.workflowConfiguration.view;
  if (actionType === "create")
    initialDataUrl = endpoints.workflowConfiguration.create;
  if (actionType === "edit")
    initialDataUrl = endpoints.workflowConfiguration.edit;

  return (
    <div className="WorkflowCreateEditDetails">
      {/* {originalActionType === "edit" && (
        <div className="EditTabBar">
          <div
            className={`Tab ${currentPage === Pages.DETAILS ? "Active" : ""}`}
            onClick={() => setCurrentPage(Pages.DETAILS)}
          >
            <div className="Text">Workflow Details</div>
          </div>

          <div
            className={`Tab ${currentPage === Pages.BUILDER ? "Active" : ""}`}
            onClick={() => setCurrentPage(Pages.BUILDER)}
          >
            <div className="Text">Workflow Builder</div>
          </div>
        </div>
      )} */}

      <div className="WorkflowHeader">
        <div className="Title">Workflow details</div>

        <div className="Info"></div>

        <div className="Section">
          <div className="Text">Section 1 of 3</div>
        </div>
      </div>

      <Entity
        initialDataUrl={initialDataUrl}
        readOnly={actionType === "view"}
        submitUrl={initialDataUrl}
        onDone={onDone}
        selectedData={selectedData}
        idFromRowOption={idFromRowOption}
        formType="json"
        readOnlyFields={
          actionType === "create" || actionType === "edit"
            ? [
                {
                  fieldName: "Id",
                  readOnlyRenderer: "integerreadonly",
                },
              ]
            : undefined
        }
        fieldRenderers={workflowRightsRenderer}
        validationSchema={workflowValidationSchema}
        readOnlyFieldRenderers={workflowReadOnlyRightsRenderer}
        nullStringValues={[]}
        fetchConfig={actionType === "create" ? undefined : fetchConfig}
        submitButtonText={submitButtonText}
        hideActionButton={hideActionButton}
        wrapperClassName="Workflows"
        groupColumns={
          actionType !== "view"
            ? {
                details: 1,
                PLACEHOLDER_COLUMN: 2,
              }
            : undefined
        }
        progressBar={
          <ProgressBar
            currentPage={currentPageNumber}
            totalPages={totalPages}
          />
        }
        cancelOnDone={cancelOnDone}
        saveSubmitResponse={true}
        onValuesChange={onValuesChangeDetails}
        conditionalFields={{
          ProgrammeID: {
            dependentField: "bUniversal",
            dependentValues: [false], // 1 = "Other user"
          },
        }}
      />
    </div>
  );
};

export default WorkflowCreateEditDetails;
